export default __webpack_public_path__ + "static/media/individual_course.7580ed56.png";